import GridTile from "../grid/GridTile";

export default class Path {
    constructor() {
        const initialCapacity = 100;

        /**
         * @constant
         * @type {Array.<GridTile>}
         */
        this.tiles = new Array(initialCapacity);
        for (let i = 0; i < initialCapacity; i++) {
            this.tiles[i] = null;
        }

        /**
         * Special purpose array for the reglar PathFinder that needs to build the path in reverse order.
         * We fill up this array backwards, and then reverse it.
         * @constant
         * @type {Array.<GridTile>}
         */
        this.pathBuilder = new Array(initialCapacity);
        for (let i = 0; i < initialCapacity; i++) {
            this.tiles[i] = null;
        }

        /**
         * @type {number}
         */
        this.pathBuilderIndex = 0;


        /**
         * @type {number}
         */
        this.size = 0;
    }

    /**
     * Add a tile to the end of the path.
     * @param {GridTile} tile 
     */
    add(tile) {
        if (this.size >= this.tiles.length) {
            for (let i = 0; i < 20; i++) {
                this.tiles.push(null);
            }    
        }

        this.tiles[this.size] = tile;
        this.size++;
    }

    addToFrontStart() {
        this.pathBuilderIndex = 0;
    }

    addToFrontEnd() {
        // reverse the tile order
        for (let i = this.pathBuilderIndex - 1; i >= 0; i--) {
            this.add(this.pathBuilder[i]);
        }
    }

    /**
     * Add a tile to the end of the path.
     * @param {GridTile} tile 
     */
    addToFront(tile) {
        if (this.pathBuilderIndex >= this.pathBuilder.length) {
            for (let i = 0; i < 20; i++) {
                this.pathBuilder.push(null);
            }    
        }

        this.pathBuilder[this.pathBuilderIndex] = tile;
        this.pathBuilderIndex++;
    }

    reset() {
        this.size = 0;

        //////this.tiles.fill(null); 
    }
}